module.exports = __webpack_public_path__ + "img/6d.d7c429d9.png";